import {  Box, Flex, HStack, Icon, Menu, Portal, Span, Text, useDisclosure } from '@chakra-ui/react'
import { Link as ChakraLink } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HashLink  } from 'react-router-hash-link';
import React from 'react'
import { useColorModeValue } from '../ui/color-mode';
import { useTranslation } from 'react-i18next';
import { LuArrowRight } from 'react-icons/lu';

const NavItems = ({data, globalColor}) => {

    const location = useLocation();
    const isActive = location.pathname === data.href;
    const gradient1 = useColorModeValue('blue.200', 'blue.800')
    const gradient2 = useColorModeValue(`${globalColor}.200`, `${globalColor}.700`)
    const textActiveColor = useColorModeValue(`${globalColor}.500`, `${globalColor}.600`)
    const { t } = useTranslation();
    const navigate = useNavigate()

      // 1. Manage open state
  const { open, onOpen, onClose } = useDisclosure();

  return (
    <ChakraLink position={'relative'} _notFirst={{
        _before: {
            content: "''",
            visibility: {md: 'visible', base: 'hidden'},
            position: 'absolute',
            w: 1,
            h: 1,
            rounded: 'full',
            left: -4,
            top: '48%',
            bgColor: useColorModeValue('gray.400', 'white'),

            //bgColor: useColorModeValue('gray.800', 'white')
        }}
    }
      asChild>
            {data.label === t('navitem3') ? 
            <Menu.Root open={open} onOpenChange={onOpen} closeOnSelect={true}>
                <Menu.Trigger
                onMouseEnter={onOpen} 
                onMouseLeave={onClose}
                 asChild>
                    <Span color={isActive && textActiveColor} fontSize={'sm'} fontWeight={'medium'} fontFamily={'Onest'}>
                        {data.label}
                    </Span>
                </Menu.Trigger>
                <Portal>
                    <Menu.Positioner>
                    <Menu.Content
                        onMouseEnter={onOpen} 
                        onMouseLeave={onClose}
                    >
                        <Menu.Item 
                        color={ location.pathname === '/services/voting' && "purple.500"}
                        _hover={{ bg: location.pathname === '/services/voting' && "purple.50", color: location.pathname === '/services/voting' &&  "purple.500" }}
                            onClick={()=>navigate('/services/voting')} 
                            fontFamily={'Onest'} 
                            display={'flex'} 
                            justifyContent={'space-between'} 
                            value="/services/voting"
                        >
                            <Text>Vote en ligne</Text>
                            <Icon color={location.pathname === '/services/voting'}>
                                <LuArrowRight/>
                            </Icon>
                        </Menu.Item>

                        <Menu.Item 
                        color={ location.pathname === '/services/tiketing' && "purple.500"}
                        _hover={{ bg: location.pathname === '/services/tiketing' && "purple.50", color: location.pathname === '/services/tiketing' &&  "purple.500" }} 
                        display={'flex'} 
                        onClick={()=>navigate('/services/tiketing')}  
                        fontFamily={'Onest'} 
                        justifyContent={'space-between'} 
                        value="new-file">
                            Billeterie en ligne
                            <Icon color={location.pathname === '/services/tiketing'}>
                                <LuArrowRight/>
                            </Icon>
                        </Menu.Item>
                        <Menu.Item 
                        color={ location.pathname === '/services/coding' && "purple.500"}
                        _hover={{ bg: location.pathname === '/services/coding' && "purple.50", color: location.pathname === '/services/coding' &&  "purple.500" }} 
                        onClick={()=>navigate('/services/coding')} 
                        display={'flex'} 
                        fontFamily={'Onest'} 
                        justifyContent={'space-between'} 
                        value="new-win"
                        >
                            Developpement d'applications
                            <Icon color={location.pathname === '/services/coding' && "purple.500"}>
                                <LuArrowRight/>
                            </Icon>
                        </Menu.Item>
                        <Menu.Item
                        display={'flex'} 
                        fontFamily={'Onest'} 
                        justifyContent={'space-between'} 
                        value="open-file"
                        >
                            Marketing Digital
                            <Icon color={'black'}>
                                <LuArrowRight/>
                            </Icon>
                        </Menu.Item>
                    </Menu.Content>
                    </Menu.Positioner>
                </Portal>
            </Menu.Root> : 
        <HashLink smooth to={data.href}>
            <HStack py={{md: 'inherit', base: 1}}>
                { isActive && <Flex display={{md: 'none', base: 'flex'}} float={'left'} mr={4} justify={'center'} align={'center'} w={'min-content'}>
                    <Box className='squircle' w={'22px'} rotate={'45deg'} bgGradient={'to-bl'}
                        gradientFrom={gradient1}
                        gradientTo={gradient2} />
                    <Span position={'absolute'} fontFamily={'Outfit'} fontSize={'xs'} fontWeight={500}>{data?.index}</Span>
                </Flex>}
                <Span color={isActive && textActiveColor} fontSize={'sm'} fontWeight={'medium'} fontFamily={'Onest'}>
                    {data.label}
                </Span>
            </HStack> 
        </HashLink>}
    </ChakraLink>
  )
}

export default NavItems
